import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { UpdateContactParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import { ListContacts } from "../queries/useListContacts";

export const UpdateContact = graphql(/* GraphQL */ `
	mutation UpdateContact($params: UpdateContactParams!) {
		updateContact(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useUpdateContact() {
	const [updateContact] = useMutation(UpdateContact, {
		refetchQueries: [ListContacts],
	});

	const handleUpdateContact = useCallback(
		async (params: UpdateContactParams) => {
			const result = await updateContact({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.updateContact.success,
				error: result.data?.updateContact.error,
			};
		},
		[updateContact]
	);

	return { handleUpdateContact };
}
